import {mapGetters, mapActions} from 'vuex'
import {getName} from '@/utils/weather'

const ManagementSection = () => import(
  /* webpackChunkName: "c-dashboard_management-section" */ '@/components/dashboard/ManagementSection')
const DisastersSection = () => import(
  /* webpackChunkName: "c-dashboard_disasters-section" */ '@/components/dashboard/DisastersSection')
const ReportsSection = () => import(
  /* webpackChunkName: "c-dashboard_reports-section" */ '@/components/dashboard/ReportsSection')

const WEATHER_ICONS = {
  CLOUDY: require('@/assets/images/icons/weather/cloudy.svg'),
  RAINING: require('@/assets/images/icons/weather/raining.svg'),
  SUNNY: require('@/assets/images/icons/weather/sunny.svg'),
  THUNDERSTORM: require('@/assets/images/icons/weather/thunderstorm.svg')
}

export default {
  name: 'DashboardPage',
  components: {
    ManagementSection,
    DisastersSection,
    ReportsSection
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters('Dashboard', ['info', 'disasters', 'reports']),
    currentTime () {
      const str = new Date(this.info.time).toGMTString()
      return str.slice(0, -7)
    },
    weather () {
      const weather = this.info.weather || {}
      const weathers = this.info.weathers
        || weather.data || []
      const timestamp = weather.timestamp
      return {
        timestamp,
        data: weathers
      }
    },
    weatherTimestamp () {
      return this.weather.timestamp
        && new Date(this.weather.timestamp)
          .toLocaleString()
    },
    weathers () {
      return this.weather.data
        .map(i => ({
        location: i.location,
        status: getName(i.status),
        temperature: i.temperature,
        icon: WEATHER_ICONS[i.status]
      }))
    }
  },
  methods: {
    ...mapActions('Dashboard', ['getInfo', 'getDisasters', 'getReports', 'fetchWeathers']),
    init () {
      this.getInfo()
      this.getDisasters()
      this.getReports()
      this.fetchWeathers()
    }
  }
}
